/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AcceptancesControllerGetAcceptancesQueryResponse, AcceptancesControllerGetAcceptancesPathParams, AcceptancesControllerGetAcceptances401 } from "../../models/acceptancesController/AcceptancesControllerGetAcceptances";

function getAcceptancesControllerGetAcceptancesUrl(principalId: AcceptancesControllerGetAcceptancesPathParams["principalId"], principalType: AcceptancesControllerGetAcceptancesPathParams["principalType"]) {
  const res = { method: 'GET', url: `/api/v1/acceptances/${principalType}/${principalId}` as const }  
  return res
}

/**
 * @summary Get all acceptances for a principal
 * {@link /api/v1/acceptances/:principalType/:principalId}
 */
export async function acceptancesControllerGetAcceptances(principalId: AcceptancesControllerGetAcceptancesPathParams["principalId"], principalType: AcceptancesControllerGetAcceptancesPathParams["principalType"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<AcceptancesControllerGetAcceptancesQueryResponse, ResponseErrorConfig<AcceptancesControllerGetAcceptances401>, unknown>({ method : "GET", url : getAcceptancesControllerGetAcceptancesUrl(principalId, principalType).url.toString(), ... requestConfig })  
  return res.data
}